import { useQuery } from "@tanstack/react-query";

import api from "@/common/utils/api";

import { orgQueryKeys } from "./orgQueryKeys";

export function useOrgMembers(orgId: string) {
  return useQuery({
    queryKey: orgQueryKeys.members(orgId),

    queryFn: () =>
      api
        .get<"/orgs/:orgId/members">(`/orgs/${orgId}/members`)
        .then((res) => res.data),
  });
}
